// extracted by mini-css-extract-plugin
export default {"root":"_36mNV","indicator":"_2synX","spinner-animation":"_2F4mD","circle":"VEoJ9","circuit":"_1L99c"};